import React from 'react'
import './ComplianceInformation.css'

const COMPLIANCE_TYPES = {
  avsApprovedOrCargoClearancePermit: 'AVS Approved / CAGO Clearance Permit',
  halalCertificate: 'Halal Certificate',
  hsaProductRegistration: 'HSA Product Registration',
  imdaRegistration: 'IMDA Registration',
  neaProductRegistration: 'NEA Product Registration',
  organicCertificate: 'Organic Certificate',
  safetyMarkRegistration: 'Safety Mark Registration',
  vectorControlRegistration: 'Vector Control Registration',
}

const ComplianceInformation = ({ keyName, i, _this }) => {
  const rawValue = _this.state.values.metaData[keyName]

  let complianceData = null
  if (rawValue) {
    try {
      complianceData =
        typeof rawValue === 'string' ? JSON.parse(rawValue) : rawValue
    } catch (e) {
      complianceData = null
    }
  }

  // Check if any certification has actual data
  const hasAnyData = Object.keys(COMPLIANCE_TYPES).some((certKey) => {
    const data = complianceData?.[certKey]
    const isValidObject =
      data && typeof data === 'object' && !Array.isArray(data)
    if (!isValidObject) {
      return false
    }
    return Boolean(data.code || data.expiryDate || data.exemption)
  })

  return (
    <div className="compliance-info-display" key={`metaData-${i}`}>
      <label className="compliance-info-label">{keyName}</label>
      {!hasAnyData ? (
        <div className="compliance-na">N/A</div>
      ) : (
      <div className="compliance-table-container">
        <table className="compliance-table">
          <thead>
            <tr>
              <th>Certification Type</th>
              <th>Code</th>
              <th>Expiry Date</th>
              <th>Exemption</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(COMPLIANCE_TYPES).map(([certKey, label]) => {
              const data = complianceData?.[certKey]
              const isValidObject =
                data && typeof data === 'object' && !Array.isArray(data)
              const code = isValidObject ? data.code : null
              const expiryDate = isValidObject ? data.expiryDate : null
              const exemption = isValidObject ? data.exemption : null
              const hasActualData = Boolean(code || expiryDate || exemption)
              return (
                <tr
                  key={certKey}
                  className={hasActualData ? 'has-data' : 'empty'}
                >
                  <td className="cert-type">{label}</td>
                  <td>{code || 'N/A'}</td>
                  <td>{expiryDate || 'N/A'}</td>
                  <td>{exemption || 'N/A'}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
      )}
    </div>
  )
}

export default ComplianceInformation
